import { call } from 'redux-saga/effects';
import { loadFileListWorker } from './loadFileListWorker';
import { LoadFileListAction } from '../actions';

export function* handleFiltersChange(action: LoadFileListAction) {
  yield call(loadFileListWorker, action);
}
